import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Registrar Partida", -1)

import { useAuth } from "@/composables/useAuth";
import { ArmyDTO } from "@/interfaces/Army";
import { CreatePartidaAmistosaDTO } from "@/interfaces/Partidas";
import { UsuarioIdNickDTO } from "@/interfaces/Usuario";
import { registrarPartida } from "@/services/PartidasAmistosasService";
import { getUsuariosIdNick } from "@/services/UsuariosService";
import { appsettings } from "@/settings/appsettings";
import { ref, watch } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRegistrarPartida',
  emits: ["close", "registroExitoso"],
  setup(__props, { emit: __emit }) {

const show = ref<boolean>(true);
const valid = ref<boolean>(false);
const form = ref();

const { getidUsuario } = useAuth();
const loading = ref(false);
const loadingNicks = ref(false);
const loadingEjercitos = ref(false);
const loadingEscenarios = ref(false);
const listaUsuarios = ref<UsuarioIdNickDTO[]>([]);
const listadoNicks = ref<string[]>([]);
const listadoEjercitos = ref<ArmyDTO[]>([]);
const listaEscenarios = ref<string[]>([]);
const ejercitoPropio = ref<ArmyDTO>();
const ejercitoRival = ref<ArmyDTO>();
const idUsuario = ref<string>(getidUsuario.value!);

const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

const emit = __emit;

const formData = ref({
  rival: "",
  miEjercito: ejercitoPropio.value,
  ejercitoRival: ejercitoRival.value,
  miResultado: null as number | null,
  resultadoRival: null as number | null,
  puntosEjercito: null as number | null,
  escenario: "",
});

const rules = {
  required: (value: any) => !!value || "Campo obligatorio",
  number: (v: any) =>
    (v !== null && v !== "" && !isNaN(v)) || "Debe ser un número válido.",
};

const close = () => {
  show.value = false;
  emit("close");
};

const registrar = async () => {
  if (form.value?.validate()) {
    loading.value = true;

    const rival = listaUsuarios.value.find(
      (u) => u.nick == formData.value.rival
    );
    if (!rival)
      throw new Error(`Rival con nick ${formData.value.rival} no encontrado`);
    if (!parseInt(idUsuario.value)) throw new Error(`Usuario no encontrado`);

    const request: CreatePartidaAmistosaDTO = {
      IdUsuario1: parseInt(idUsuario.value),
      IdUsuario2: rival.idUsuario,
      resultadoUsuario1: formData.value.miResultado!,
      resultadoUsuario2: formData.value.resultadoRival!,
      puntosPartida: formData.value.puntosEjercito!,
      esMatchedPlayPartida: false,
      escenarioPartida: formData.value.escenario,
      esTorneo: false,
      ejercitoUsuario1: formData.value.miEjercito!,
      ejercitoUsuario2: formData.value.ejercitoRival!,
      esElo: false,
      partidaValidadaUsuario1: true,
    };

    try {
      await registrarPartida(request);
      showSuccessModal.value = true;
      emit("registroExitoso");
    } catch {
      showErrorModal.value = true;
    } finally {
      loading.value = false;
    }
  }
};

watch(showSuccessModal, (newVal) => {
  if (!newVal) {
    close();
  }
});

const loadNicks = async () => {
  loadingNicks.value = true;
  try {
    if (!listaUsuarios.value.length) {
      const response = await getUsuariosIdNick();
      listaUsuarios.value = (response.data as UsuarioIdNickDTO[]).filter(
        (u) => u.idUsuario !== parseInt(idUsuario.value)
      );
    }
    listadoNicks.value = listaUsuarios.value.map((u) => u.nick).sort();
  } catch (error) {
    console.error("Error al obtener los nicks:", error);
  } finally {
    loadingNicks.value = false;
  }
};

const loadEjercitos = async () => {
  loadingEjercitos.value = true;
  listadoEjercitos.value = appsettings.armies;
  loadingEjercitos.value = false;
};

const loadEscenarios = async () => {
  loadingEscenarios.value = true;
  listaEscenarios.value = appsettings.escenarios;
  loadingEscenarios.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((show).value = $event)),
      "max-width": "600"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  onClick: close
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "form",
                  ref: form,
                  modelValue: valid.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((valid).value = $event)),
                  "lazy-validation": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: formData.value.rival,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.rival) = $event)),
                              items: listadoNicks.value,
                              label: "Rival",
                              rules: [rules.required],
                              loading: loadingNicks.value,
                              onClick: loadNicks,
                              clearable: ""
                            }, null, 8, ["modelValue", "items", "rules", "loading"]),
                            (loadingNicks.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                  key: 0,
                                  indeterminate: "",
                                  color: "primary",
                                  height: "2",
                                  class: "mt-1"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: formData.value.miEjercito,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.miEjercito) = $event)),
                              items: listadoEjercitos.value,
                              "item-title": "name",
                              label: "Mi ejercito",
                              rules: [rules.required],
                              loading: loadingEjercitos.value,
                              onClick: loadEjercitos,
                              clearable: ""
                            }, null, 8, ["modelValue", "items", "rules", "loading"]),
                            (loadingEjercitos.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                  key: 0,
                                  indeterminate: "",
                                  color: "primary",
                                  height: "2",
                                  class: "mt-1"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: formData.value.ejercitoRival,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.ejercitoRival) = $event)),
                              items: listadoEjercitos.value,
                              "item-title": "name",
                              label: "Ejército rival",
                              rules: [rules.required],
                              loading: loadingEjercitos.value,
                              onClick: loadEjercitos,
                              clearable: ""
                            }, null, 8, ["modelValue", "items", "rules", "loading"]),
                            (loadingEjercitos.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                  key: 0,
                                  indeterminate: "",
                                  color: "primary",
                                  height: "2",
                                  class: "mt-1"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: formData.value.miResultado,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.miResultado) = $event)),
                              label: "Mi resultado",
                              type: "number",
                              rules: [rules.number]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: formData.value.resultadoRival,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.resultadoRival) = $event)),
                              label: "Resultado rival",
                              type: "number",
                              rules: [rules.number]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: formData.value.puntosEjercito,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.puntosEjercito) = $event)),
                              label: "Puntos de los ejércitos",
                              type: "number",
                              rules: [rules.number]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: formData.value.escenario,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.escenario) = $event)),
                              items: listaEscenarios.value,
                              label: "Escenario",
                              loading: loadingEscenarios.value,
                              onClick: loadEscenarios,
                              clearable: ""
                            }, null, 8, ["modelValue", "items", "loading"]),
                            (loadingEscenarios.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                  key: 0,
                                  indeterminate: "",
                                  color: "primary",
                                  height: "2",
                                  class: "mt-1"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "secondary",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: registrar,
                  loading: loading.value,
                  disabled: loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Registrar ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Partida creada con éxito.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido crear la partida.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})